import { useEffect, useRef, useState } from "react";

import { fetchReportData } from "../../services/network";
import Phi from "../../Phi/Phi";

import StudentCard from "../../Components/UI/StudentCard";
import BMICard from "../../Components/report/growthReport/BMICard";
import NewHeightWeightCard from "../../Components/report/growthReport/NewHeightWeightCard";
import Precaution from "../../Components/UI/Precaution";
import ReportFooter from "../../Components/UI/ReportFooter";

import SimpleLoader from "../../Components/Loaders/SimpleLoader";

import {
  BmiHeightIconSvg,
  BmiWeightIconSvg,
  GirlIconSvg,
  UserIconSvg,
} from "../../utils/Svgs";

import { ReportRXData } from "../../utils/helpers/newReportHelper";
import { PALLETTE } from "../../utils/theme";
import { V2ReportStyle } from "../../styles/V2ReportStyle";
import { useGrowthReport } from "../../Store/useGrowthReport";
import ScreenShotWrapper from "../../Components/report/ScreenShotWrapper";
import Page from "./Page";
import { generateReportLogic } from "../../services/reportService";
import { useUserStore } from "../../Store/userStore";
import ReportHeader from "../../Components/report/ReportHeader";
import AssessmentNotDoneWrapper from "../../Components/report/AssessmentNotDoneWrapper";

const GrowthReportScreen = ({ location }: { location: any }) => {
  const [assessmentError, setAssessmentError] = useState(null);

  const growthReport = useGrowthReport((state) => state);
  const { handleMspLogo, mspLogo } = useUserStore((state) => state);
  const sessionData = sessionStorage.getItem("report_navigation_state");
  const storedParams = sessionData ? JSON.parse(sessionData) : {};

  // Reads location.state if navigated internally, falls back to sessionStorage for new tab
  const params = location?.state || storedParams;

  const [loading, setLoading] = useState(false);

  const pdfWrapperRef = useRef<any>(null);

  const studentId = params?.user_id || params?.student_id;
  const eventTrackId = params?.eventTrackId;
  const activityId = params?.activityId;

  // console.log("params", JSON.stringify(params, null, 2));
  // console.log("mspLogo", JSON.stringify(mspLogo, null, 2));

  const jwt = Phi.getSession()?.jwt;

  const getchData = async (activity_id: number, assessmentId: number) => {
    try {
      setLoading(true);

      const res = await fetchReportData({
        activity_id,
        student_id: studentId,
        jwt,
        event_track_id: assessmentId,
      });

      if (res?.results?.length > 0) {
        const parsedAssessment = JSON.parse(res.results[0].assessmentdata);

        if (parsedAssessment?.data?.Eye_Incomplete_Remark == "105") {
          setAssessmentError(true);
        }

        growthReport.handleGrowthReportData(parsedAssessment);
        await generateReportLogic({
          jwt: jwt,
          studentId: studentId,
          handleMspLogo,
        });
      }
    } catch (error) {
      console.error("error getting growth report", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getchData(activityId, eventTrackId);
  }, []);

  const growthData = growthReport.GrowthReportData;

  return (
    <div
      style={{
        ...V2ReportStyle.mainContainer,
        backgroundColor: PALLETTE.white,
        minHeight: "100vh",
      }}
    >
      {loading ? (
        <SimpleLoader />
      ) : (
        <>
          <ReportHeader title="Growth Report" pdfWrapperRef={pdfWrapperRef} />

          <ScreenShotWrapper
            ref={pdfWrapperRef}
            studentName={params?.name || params?.studentname}
            reportType="Growth"
          >
            {(targetRef: any) => (
              <div
                ref={targetRef}
                style={{
                  padding: "3rem",
                  backgroundColor: PALLETTE.background,
                }}
              >
                {assessmentError ? (
                  <AssessmentNotDoneWrapper>
                    <StudentCard
                      name={params?.name || params?.studentname}
                      schoolName={params?.class}
                      icon={
                        params?.gender === "FEMALE" || params?.gender == "F" ? (
                          <GirlIconSvg />
                        ) : (
                          <UserIconSvg />
                        )
                      }
                    />
                  </AssessmentNotDoneWrapper>
                ) : (
                  <Page>
                    <StudentCard
                      name={params?.name || params?.studentname}
                      schoolName={params?.class}
                      icon={
                        params?.gender === "FEMALE" || params?.gender == "F" ? (
                          <GirlIconSvg />
                        ) : (
                          <UserIconSvg />
                        )
                      }
                    />

                    <BMICard
                      gender={growthData?.gender}
                      type={growthData?.bmi_range?.toLowerCase()}
                      lable={
                        growthData?.bmi > growthData?.bmi_normal_upper ||
                        growthData?.bmi < growthData?.bmi_normal_lower
                          ? "Need Attention"
                          : "Normal"
                      }
                      data={growthData}
                    />

                    <NewHeightWeightCard
                      icon={<BmiHeightIconSvg />}
                      hwData={`${growthData?.height?.toFixed(1)} cms`}
                      lable={
                        growthData?.height > growthData?.height_normal_upper ||
                        growthData?.height < growthData?.height_normal_lower
                          ? "Need Attention"
                          : "Normal"
                      }
                      title="Height"
                      description={
                        <span>
                          National Height range for a{" "}
                          <strong>{growthData?.age_text}</strong>{" "}
                          <strong>
                            {growthData?.gender === "M" ? "boy" : "girl"}
                          </strong>{" "}
                          is{" "}
                          <strong>
                            {growthData?.height_normal_lower} to{" "}
                            {growthData?.height_normal_upper} cms
                          </strong>
                          . Your child is within the{" "}
                          <strong>{growthData?.height_range}</strong> for{" "}
                          {growthData?.gender === "M" ? "his" : "her"} age.
                        </span>
                      }
                    />

                    <NewHeightWeightCard
                      icon={<BmiWeightIconSvg />}
                      hwData={`${growthData?.weight?.toFixed(1)} kgs`}
                      lable={
                        growthData?.weight > growthData?.weight_normal_upper ||
                        growthData?.weight < growthData?.weight_normal_lower
                          ? "Need Attention"
                          : "Normal"
                      }
                      title="Weight"
                      description={
                        <span>
                          Your child’s weight is{" "}
                          <strong>{growthData?.weight?.toFixed(1)} kgs.</strong>
                        </span>
                      }
                    />

                    <Precaution data={ReportRXData.growth} />

                    <ReportFooter
                      designation={growthData?.physical_doctor_designation}
                      doctorName={growthData?.physical_doctor_no}
                      docSignature={growthData?.physical_doctor_path}
                      hospitalName={mspLogo[eventTrackId]}
                    />
                  </Page>
                )}
              </div>
            )}
          </ScreenShotWrapper>
        </>
      )}
    </div>
  );
};

export default GrowthReportScreen;
